<template>
  <v-tabs
    show-arrows
  >
    <v-tabs-slider color="blue"></v-tabs-slider>

    <v-tab
      v-for="tab in tabs"
      :key="tab.key"
      :href="'#tab-' + tab.key"
    >
      {{ tab.label }}
    </v-tab>

    <v-tabs-items>
      <v-tab-item
        v-for="tab in tabs"
        :key="tab.key"
        :value="'tab-' + tab.key"
      >
        <v-card flat style="height:95vh; overflow-y: auto">
          <img alt="Logo" width="100%" src="../../../assets/oil-wells/chart-1.png" />
          <img alt="Logo" width="100%" src="../../../assets/oil-wells/chart-2.png" />
          <!-- <img alt="Logo" width="100%" src="../../../assets/oil-wells/chart-3.png" /> -->
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-tabs>
</template>
<script>
import tabs from "./lib/main-tabs"
  export default {
    data () {
      return {
        tabs,
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
      }
    }
  }
</script>